import { render, staticRenderFns } from "./EntriesChart.vue?vue&type=template&id=f0967d1e&scoped=true&"
import script from "./EntriesChart.vue?vue&type=script&lang=js&"
export * from "./EntriesChart.vue?vue&type=script&lang=js&"
import style0 from "./EntriesChart.vue?vue&type=style&index=0&id=f0967d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0967d1e",
  null
  
)

export default component.exports